<div class="row">
  @for (dropdownControl of dropdownArray.controls; track dropdownControl; let i = $index; let last = $last) {
    <div [attr.title]="getDisabledTooltip(i)"
         class="col">
      <app-ace-select
          [loading]="loading"
          [appendTo]="appendTo"
          [formControl]="dropdownControl"
          [items]="itemsHierarchy && i < itemsHierarchy.length ? itemsHierarchy[i].get(i > 0 ? dropdownArray.value[i - 1] : null) : []"
          [bindLabel]="bindLabels && i < bindLabels.length ? bindLabels[i] : undefined"
          [bindValue]="bindValues && i < bindValues.length ? bindValues[i] : undefined"
          [compareWith]="compareWith && i < compareWith.length ? compareWith[i] : undefined"
          [placeholder]="placeHolders && i < placeHolders.length ? placeHolders[i] : undefined"
          [multiSelect]="multiSelect && (i === dropdownArray.length - 1)"
          [hideSelected]="false"
          (touched)="onDropdownTouched()">
        @if (finalOptionTemplate && last) {
          <ng-template #optionTemplate let-item="item">
            <ng-container *ngTemplateOutlet="finalOptionTemplate; context:{item: item}"/>
          </ng-template>
        }
      </app-ace-select>
    </div>
  }
</div>
